import { Select } from 'antd'

const AlumniOrganizationJoinRibbon = ({
  filterValue,
  setFilterValue,
}) => {
  let statusItems = [
    {  
      value: 0, 
      label: '全部'
    },
    {
      value: 1,
      label: '未审核'
    },
    {
      value: 2,
      label: '通过'
    },
    {
      value: 3,
      label: '拒绝'
    }
  ]

  const clickStatusFilter = (value) => {
    setFilterValue({ ...filterValue, status: value })
  }

  return (
    <div className='ribbon-page'>
      <div className='ribbon-container'>
        <Select
          placeholder="审核状态"
          options={statusItems}
          style={{height: '32px', width: '200px'}}
          onChange={(value) => clickStatusFilter(value)}
        />
      </div>
    </div>
  )
}

export default AlumniOrganizationJoinRibbon
